import React from 'react';
import './PlatformAdvantages.css';

// Import relevant icons for the feature cards
import { FaChartLine, FaGlobeAmericas, FaCogs, FaSatelliteDish } from 'react-icons/fa';

// Data for the four feature cards
const advantagesData = [
  {
    icon: <FaChartLine />,
    title: 'Extensive market visibility',
    description: 'Stay ahead with a 360° view across commodities, regions, and market layers.'
  },
  {
    icon: <FaGlobeAmericas />,
    title: 'Powerful data visualization',
    description: 'Translate complex data into easy, actionable stories through sharp visualisation.'
  },
  {
    icon: <FaCogs />,
    title: 'Built to fit your workflow',
    description: 'Integrate insights directly into your existing tools without disrupting how you work.'
  },
  {
    icon: <FaSatelliteDish />,
    title: 'Ground-truth validation with alternative data',
    description: 'Leverage satellite, sensor, and unconventional data streams that reflect the on-ground market reality.'
  }
];

const PlatformAdvantages = () => {
  return (
    <section className="platform-advantages-section">
      <div className="platform-advantages-container">
        <div className="section-header">
          <h2>Advantages of CRISHI data platform</h2>
          <div className="header-line"></div>
        </div>

        <div className="advantages-grid">
          {advantagesData.map((item, index) => (
            <div key={index} className="advantage-card">
              <div className="advantage-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformAdvantages;